import { ValidatorFn } from '@angular/forms';

const addressCardRegex = new RegExp('^[0-9]{6}[A-Z]{2}$');

export const addressCardValidator: ValidatorFn = (control) => {
  const error = {
    addressCard: true,
  };

  if (control.value) {
    if (typeof control.value !== 'string') {
      return error;
    }

    const preformattedValue = control.value.trim().toUpperCase();

    if (!addressCardRegex.test(preformattedValue)) {
      return error;
    }
  }

  return null;
};
